import React, { useState } from "react";
import Button from "../UI/Button";
import { rewardsOverviewText } from "../../settings/Constants";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";
import { guestbookSites, environment } from "../../settings/websiteURLs";

const FooterContainer = styled.div`
  display: flex;
  margin-top: ${rem("49px")};

  ${({ theme }) => theme.tablet`
    flex-direction: column;
  `}
`;

const FooterContent = styled.div`
  width: ${rem("440px")};
  margin: auto;

  ${({ theme }) => theme.tablet`
    width: auto;
  `}
`;

const FooterContentText = styled.div`
  ${({ type, darkMode }) =>
    type == "header" &&
    css`
      font-size: ${rem("42px")};
      font-weight: 500;
      color: #${darkMode === "true" ? "FFFFFF" : "343638"};
      line-height: ${rem("55px")};
      margin-bottom: ${rem("22px")};

      ${({ theme }) => theme.tablet`
      font-size: ${rem("36px")};
    `}
    `}

  ${({ type, darkMode }) =>
    type == "subtext" &&
    css`
      font-size: ${rem("18px")};
      font-weight: 400;
      color: #${darkMode === "true" ? "FFFFFF" : "757575"};
      line-height: ${rem("30px")};
    `}
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${rem("41px")};

  > a {
    > button {
      font-weight: 600;
      color: #343638;
      border: 1px solid #343638;
    }
  }

  ${({ theme }) => theme.tablet`
      flex-wrap: wrap;
      justify-content: space-evenly;

      > :first-child {
        margin-bottom: ${rem("16px")};
      }
  `}
`;

const ImageContainer = styled.div`
  padding-left: ${rem("56px")};

  ${({ theme }) => theme.tablet`
      padding-left: ${rem("0px")};
      margin: ${rem("24px")} auto ${rem("0px")};
  `}

  > img {
    max-width: ${rem("420px")};

    ${({ theme }) => theme.tablet`
      display: none;
    `}
  }
`;

const Footer = ({ widgetIdentifier, darkMode }) => {
  // TODO: look into creating a variable on RA to allow custom links.
  const wid =
    widgetIdentifier === "legacyvacationbrigantine"
      ? "legacyvacationresorts"
      : widgetIdentifier;
  const signupLink =
    "/reward_sign_up/" +
    wid +
    "?utm_source=irp&utm_medium=irp&utm_campaign=irp";

  return (
    <FooterContainer>
      <FooterContent>
        <FooterContentText type="header" darkMode={darkMode}>
          {rewardsOverviewText.signupCard.header}
        </FooterContentText>
        <FooterContentText type="subtext" darkMode={darkMode}>
          {rewardsOverviewText.signupCard.description}
        </FooterContentText>
        <ButtonWrapper>
          <Button
            kind="rewards_overview"
            inverted
            href={guestbookSites[environment].guestbook.url + signupLink}
            targetBlank={true}
            width="210px"
          >
            {rewardsOverviewText.signupCard.footerSignup}
          </Button>
          <Button
            kind="rewards_overview"
            inverted
            href={
              guestbookSites[environment].guestbook.url + "/redeem?spu=true"
            }
            targetBlank={true}
            width="210px"
          >
            {rewardsOverviewText.signupCard.login}
          </Button>
        </ButtonWrapper>
      </FooterContent>
      <ImageContainer>
        <img src={rewardsOverviewText.signupCard.footerImage}></img>
      </ImageContainer>
    </FooterContainer>
  );
};

Footer.propTypes = {
  widgetIdentifier: PropTypes.string.isRequired,
  darkMode: PropTypes.string,
};

export default Footer;
